import api from '@/api';

export default {
  // 바로가기 가져오기
  getShortcutInfoList(webpartId: string): Promise<webpartShortcut.Shortcut[]> {
    return api.get<webpartShortcut.Shortcut[]>({
      url: `/Webpart/WebpartShortcut/api/getList?webpartId=${webpartId}`,
    });
  },
};
